<template>
  <div class="review-sidebar-detail pb-8 px-4">
    <div class="name text-base font-medium">{{ review.customer }}</div>
    <div class="date text-xs text-gray-500">
      {{
        formatDate(review.created_at, $i18n.locale.toString(), 'MMMM DD, YYYY')
      }}
    </div>
    <div class="text text-gray-600 mt-5" v-html="review.review" />
    <div
      v-if="review?.media?.data?.length"
      class="media flex-col flex gap-3 mt-5"
    >
      <template v-for="media in review.media?.data">
        <LazyReviewVideoPlayer
          v-if="media.mediaType === 'video'"
          :key="media.id"
          :source="media.cdn_url || media.url"
          :source-stream="media.streaming_url"
        />

        <NuxtLazyImg
          v-if="media.mediaType === 'photo'"
          :key="media.id"
          :src="media.crop.cropImg || media.thumb || media.cdn_url"
          class="rounded-lg w-full h-auto"
        />
      </template>
    </div>

    <ReviewPartnerReply
      class="mt-4"
      v-if="review.supplier_reply"
      :reply="review.supplier_reply"
      expanded
    />
  </div>
</template>

<script setup lang="ts">
import { formatDate } from '~/utils/dateHelpers'
import type { Review } from '~/composables/types/event'
import ReviewPartnerReply from '~/components/review/ReviewPartnerReply.vue'

withDefaults(defineProps<{ review: Review }>(), {
  review: () => ({}) as Review,
})
</script>
